
define('text!plugins/readonly/setupTemplate.html',[],function () { return '';});

